import StageSystem from "./stage";
import MouseSystem from "./mouse";
import PointerSystem from "./pointer";
import KeyboardSystem from "./keyboard";
import { Application, Container, Renderer } from "pixi.js";
import { World } from "ecsy";

export default class Platform {
  constructor(canvas: HTMLCanvasElement, width: number, height: number) {
    this._app = new Application({ view: canvas, width: width, height: height });
    this._app.stage.interactive = true;
    this._stage = new StageSystem(width, height);
    this._world = new World();

    const frameLength = 1 / 60;
    this._app.ticker.add(a => {
      this._world.execute(frameLength * a, 0);
    });
  }

  destroy(): void {
    this._app.destroy(false, {
      children: true,
      baseTexture: true,
      texture: true
    });
  }

  reset(): void {
    var systems = this._world.getSystems();
    systems.forEach(system => {
      if ((system as any).dispose) {
        (system as any).dispose();
      }
    });
    this._world.stop();
    this._world = new World();
    this._app.stage.removeChildren();
  }

  get renderer(): Renderer {
    return this._app.renderer;
  }

  get stage(): StageSystem {
    return this._stage;
  }

  get world(): World {
    return this._world;
  }

  get mouse(): MouseSystem {
    if (this._mouse === null) {
      this._mouse = new MouseSystem(this._app.renderer.plugins.interaction);
    }
    return this._mouse;
  }

  get pointer(): PointerSystem {
    if (this._pointer === null) {
      this._pointer = new PointerSystem(this._app.renderer.plugins.interaction);
    }
    return this._pointer;
  }

  get container(): Container {
    return this._app.stage;
  }

  get keyboard(): KeyboardSystem {
    if (this._keyboard === null) {
      this._keyboard = new KeyboardSystem();
    }
    return this._keyboard;
  }

  private _stage: StageSystem;
  private _mouse: MouseSystem | null = null;
  private _pointer: PointerSystem | null = null;
  private _keyboard: KeyboardSystem | null = null;
  private _app: Application;
  private _world: World;
}
